export var SortOrder;
(function (SortOrder) {
    SortOrder["asc"] = "ASC";
    SortOrder["desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var ConditionType;
(function (ConditionType) {
    ConditionType["and"] = "AND";
    ConditionType["or"] = "OR";
})(ConditionType || (ConditionType = {}));
export var FilterOperatorTypes;
(function (FilterOperatorTypes) {
    FilterOperatorTypes["empty"] = "EMPTY";
    FilterOperatorTypes["notEmpty"] = "NOT_EMPTY";
    FilterOperatorTypes["equals"] = "EQUALS";
    FilterOperatorTypes["notEquals"] = "NOT_EQUALS";
    FilterOperatorTypes["greaterThanOrEqual"] = "GTE";
    FilterOperatorTypes["greaterThan"] = "GT";
    FilterOperatorTypes["lessThanEqual"] = "LTE";
    FilterOperatorTypes["lessThan"] = "LT";
    FilterOperatorTypes["is"] = "IS";
    FilterOperatorTypes["isNot"] = "IS_NOT";
    FilterOperatorTypes["contains"] = "CONTAINS";
    FilterOperatorTypes["notContains"] = "NOT_CONTAINS";
    FilterOperatorTypes["startsWith"] = "STARTS_WITH";
    FilterOperatorTypes["endsWith"] = "ENDS_WITH";
    FilterOperatorTypes["in"] = "IN";
    FilterOperatorTypes["notIn"] = "NOT_IN";
})(FilterOperatorTypes || (FilterOperatorTypes = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["term"] = "TERM";
    AggregationType["range"] = "RANGE";
    AggregationType["max"] = "MAX";
    AggregationType["min"] = "MIN";
    AggregationType["stats"] = "STATS";
    AggregationType["sum"] = "SUM";
    AggregationType["uniqCount"] = "CARDINALITY";
    AggregationType["count"] = "VALUE_COUNT";
    AggregationType["avg"] = "AVG";
    AggregationType["dateHistogram"] = "DATE_HISTOGRAM";
    AggregationType["autoDateHistogram"] = "AUTO_DATE_HISTOGRAM";
})(AggregationType || (AggregationType = {}));
export var MetricAggregation;
(function (MetricAggregation) {
    MetricAggregation["avg"] = "avg";
    MetricAggregation["count"] = "value_count";
    MetricAggregation["distinct"] = "cardinality";
    MetricAggregation["max"] = "max";
    MetricAggregation["min"] = "min";
    MetricAggregation["sum"] = "sum";
})(MetricAggregation || (MetricAggregation = {}));
//# sourceMappingURL=searchTypes.js.map